import type { Method } from 'lib/axios';
import { APICallV2Post, APICallV4 } from 'reactApp/api/APICall';
import { apiMigrateWeblinksV2ToV4 } from 'reactApp/appHelpers/featuresHelpers';
import { CloudActions } from 'reactApp/constants/cloudActions';

const method = 'weblinks/editable';

class WeblinksEditableOnAPIV2Call extends APICallV2Post {
    _method = `${method}/on`;
    _headers = { 'X-VFS-Action': CloudActions.LINK_RIGHTS };
}

class WeblinksEditableOnAPIV4Call extends APICallV4 {
    _method = method;
    _type: Method = 'post';
    _headers = { 'X-VFS-Action': CloudActions.LINK_RIGHTS };
}

export const weblinksEditableOnApiCall = (params: Record<string, any>): Promise<unknown> => {
    if (apiMigrateWeblinksV2ToV4.editable) {
        return new WeblinksEditableOnAPIV4Call().makeRequest({
            weblink_id: params.weblink,
            enable: true,
        });
    }

    return new WeblinksEditableOnAPIV2Call().makeRequest(params);
};
